import MeasurementContextDisplay from 'components/tables/data/fault/MeasurementContextDisplay';
import { FaultRow } from 'components/tables/data/fault/types';

/**
 * Column for the measurement row context where the fault was found.
 */
export default function MeasurementContextColumn({
  data: { measurementContext, measurementContextText },
}: {
  data: FaultRow;
}) {
  if (!measurementContext) {
    return null;
  }

  return <MeasurementContextDisplay measurementContext={measurementContext} text={measurementContextText} />;
}
